function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M173.879 148.976C212.826 154.736 240 167.762 240 182.91c0 20.484-49.696 37.09-111 37.09S18 203.394 18 182.91c0-15.148 27.174-28.174 66.121-33.934 13.378 2.72 28.656 4.262 44.879 4.262 15.816 0 30.734-1.465 43.87-4.057zM157.093 87.99c35.275 3.929 60.707 15.05 60.707 28.158 0 16.387-39.757 29.672-88.8 29.672s-88.8-13.285-88.8-29.672c0-13.107 25.432-24.23 60.707-28.157 8.64 1.413 18.132 2.193 28.093 2.193 9.612 0 18.788-.727 27.183-2.047z"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 66.6,
  cy: 22.254,
  rx: 66.6,
  ry: 22.254,
  transform: "translate(62.4 39.742)"
});

function SvgBalancer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 258 258",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancer);
export default __webpack_public_path__ + "static/media/Balancer.07e3d239.svg";
export { ForwardRef as ReactComponent };